import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import MenyLocalStorage from "@app/MenyLocalStorage"
import { hideQuestbackFeedbackPopup } from "@app/store/app/appActions"
import { RootState } from "@app/types"
import Button from "@ng-mw/reol/components/Button"
import Icon from "@ng-mw/reol/components/Icon"
import leaf4Icon from "@resources/icons/leaf4"
import PopupContent from "@modules/popup/PopupContent"
import PopupText from "@modules/popup/PopupText"
import { triggerEventNow } from "@modules/shared/MessageAfterEvent"
import FeedbackDrawer from "../FeedbackDrawer"

type QuestbackStep = "intro" | "survey"

const QuestbackFeedbackPopup = () => {
    const dispatch = useDispatch<any>()
    const { data, visible } = useSelector((state: RootState) => state.app.questbackFeedbackPopup)
    const [step, setStep] = useState<QuestbackStep>("intro")

    useEffect(() => {
        if (!visible) {
            setStep("intro")
            return
        }

        setStep(data?.skipIntroStep ? "survey" : "intro")
    }, [visible, data?.id, data?.skipIntroStep])

    const close = () => {
        if (data?.id) {
            triggerEventNow(`${MenyLocalStorage.UserInteractedWithFeedback}${data.id}`)
        }
        dispatch(hideQuestbackFeedbackPopup())
    }

    const handlePrimaryAction = () => {
        if (!data) return
        setStep("survey")
    }

    const isSurveyStep = data?.skipIntroStep || step === "survey"
    const introText = data?.isThumbsUp ? data.thumbsUpResponse : data?.thumbsDownResponse

    return (
        <FeedbackDrawer
            drawerSize={isSurveyStep ? "tall" : "dynamic"}
            footer={
                !isSurveyStep ? (
                    <div className="feedback-form__actions">
                        <Button
                            text="Si din mening"
                            onClick={handlePrimaryAction}
                        />
                    </div>
                ) : null
            }
            isOpen={visible}
            onClose={close}
        >
            {isSurveyStep ? (
                data?.questbackUrl ? (
                    <iframe
                        className="feedback-form__iframe"
                        src={data.questbackUrl}
                        title="Questback spørreundersøkelse"
                    />
                ) : null
            ) : (
                <div className="feedback-form feedback-form--questback">
                    <div
                        className="feedback-form__illustration"
                        aria-hidden="true"
                    >
                        <Icon
                            icon={leaf4Icon}
                            size={{ width: "128px", height: "40px" }}
                            isInline
                        />
                    </div>
                    <h2 className="feedback-form__title">
                        Takk for din tilbakemelding!
                    </h2>
                    <PopupContent>
                        <PopupText>
                            <p>{introText}</p>
                        </PopupText>
                    </PopupContent>
                </div>
            )}
        </FeedbackDrawer>
    )
}

export default QuestbackFeedbackPopup
